
import { seasondefaults } from './seasondefaults'

export const posteventdefaults = {
    ...seasondefaults,
    currentWizardStep:1,
    eventRetrieved:false,  
    inWizardMode:false,
    eventId:0,
    fetchingevent:false,
    eventname:'',
    advancers:[],
    alternates:[],
    searching:false,
    pendinguploads:[],
    uploadingfile:false,
    hasDirectorRole:true,
    hasAdminRole:false,
    savingComponentState:false,
    componentStateSaved:false,
    nameoncard:'',
    ccnumber:'',
    expiration:'',
    cvc:'',
    savingPayment:false,
    paymentAmount:null,
    paymentDate:null,
    paymentError:'',
    paymentConfirmation:'',
    advancerPolicy:null,
    advancerRatio:null,
    mixedAgeDivisions:[],
    updateErrors:{},
    updateRecordAdvancersErrors:{},
    updateDepositErrors:{},
    updateRulesErrors:{},
    norecordsfound:false,
    updateSetupErrors:{},
}


// WEBPACK FOOTER //
// ./src/utils/constants/posteventdefaults.js